import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-bootstrap-modal'
import { useForm } from 'react-hook-form'
import TextInput from './inputs/text-input'
import PhotoInput from './inputs/photo-input'
import SelectInput from './inputs/select-input'
import { patchForm, postForm } from '../../ajax'
import FlashAlert from '../../components/flash-alert'

function FormModal({data, regions, onClose, onCreate, onUpdate}) {
  const isNew = !data.id
  const requiredMsg = 'Is required'
  const [loading, setLoading] = useState(false)
  const [alert, setAlert] = useState()
  const [fileLoaded, setFileLoaded] = useState(false)
  const [imageError, setImageError] = useState(null)
  const { register, reset, setValue, getValues, handleSubmit, formState: { errors } } = useForm()
  const imageUrl = getValues('image_url')
  const regionOptions = [['', 'Select'], ...regions.map(r => [r.id, r.name])]

  useEffect(() => {
    reset(_.omit(data, 'id', 'region_name'))
  }, [data])

  const prepareFormData = (data) => {
    let formData = new FormData()
    for (const key in data) {
      formData.append(`banner[${key}]`, data[key])
    }
    return formData
  }

  const submitUrl = () => {
    if (isNew) return '/admins/banners'

    return `/admins/banners/${data.id}`
  }

  const onSubmit = async (data) => {
    if (!validateImage()) return

    let formData = prepareFormData(data)
    const submitMethod = isNew ? postForm : patchForm

    setLoading(true)
    const response = await submitMethod(submitUrl(), formData)
    const json = await response.json()
    setLoading(false)
    if (json.alert)
      setAlert(json.alert)
    else {
      const admin = json.admin
      isNew ? onCreate(admin) : onUpdate(admin)
    }
  }

  const loadFile = (file) => {
    const fr = new FileReader()
    fr.onloadend = function() { 
      setValue('image_url', fr.result)
      setImageError()
      setFileLoaded(file.name)
    }
    fr.readAsDataURL(file)
  }

  const fileSelected = (file) => {
    if (file.size > 10000000) return window.alert('File size limit is 10MB')    
    if (file.type != 'image/png') return window.alert(' Only PNG files are allowed')

    loadFile(file)
  }

  const validateImage = () => {
    if (!imageUrl) {
      setImageError({message: requiredMsg})
      return false
    }
    return true
  }

  const validatePresence = (value) => {
    if (!value.trim()) return requiredMsg
  }

  return (
    <Modal dialogClassName='banner-modal' container={document.body} show={true} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{isNew ? 'New Banner' : 'Edit Banner'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        { alert && <FlashAlert text={alert.text} type={alert.type} onHide={() => setAlert(null)} /> }
        { loading && <div className='animated-spinner'></div> }
        <form className={'banner-form' + (loading ? ' isLoading' : '')} onSubmit={handleSubmit(onSubmit)}>
          <TextInput
            {...register('name', { required: 'Is required', validate: validatePresence })}
            label='Banner Name'
            error={errors && errors.name}
            onChange={e => setValue('name', e.target.value)}
          />
          <PhotoInput imageUrl={imageUrl} onFileLoad={fileSelected} error={imageError} />
          <TextInput
            {...register('url', {
              pattern: {
                value: /^(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})(\.[a-zA-Z0-9]{2,})?/i,
                message: 'Invalid URL'
              } 
            })}
            label='URL'
            error={errors && errors.url}
            onChange={e => setValue('url', e.target.value)}
          />
          <SelectInput
            {...register('region_id', { required: 'Is required' })}
            label='Region'
            options={regionOptions}
            error={errors && errors.region_id}
            onChange={e => setValue('region_id', e.target.value)}
          />
          <div className='form-action'>
            <input type='submit' value={isNew ? 'Create' : 'Update'} className='btn btn-primary' />
          </div>
        </form>
      </Modal.Body>
    </Modal>
  )
}

FormModal.propTypes = {
  data: PropTypes.object.isRequired,
  regions: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
}

export default FormModal

